import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export interface ModelGroupDTO {
  groupId: string;
  groupName: string;
}

const fetchModelPortfolioGroups = async (): Promise<ModelGroupDTO[]> => {
  const { modelPortfoliosGroups } = await authFetch(
    urlWithParams('/Adviser/ModelPortfoliosGroups', { onlyOrionGroups: true }),
  );

  return modelPortfoliosGroups;
};

export const useModelPortfolioGroupsQuery = () => {
  return useQuery(
    queryKeys.modelPortfolioGroups(),

    () => fetchModelPortfolioGroups(),

    {
      cacheTime: 0,
    },
  );
};
